import axios from "../helpers/axioxInstance";
import URLS from "../constData/urls";

const tableURLMapping = {
  drmBidTableData: URLS.DRM_MAKE_TO_PROCESS,
};
export const drmSubmitTableData = async ([userCode, submitDetails, tableName, controller]) => {
  const response = await axios.post(
    `${tableURLMapping[tableName]}`,
    { userCode, submitDetails },
    { signal: controller.signal }
  );

  if (response.status >= 400) {
    throw new Error(response.message);
  }
  return response;
};
